var _rect, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel3Badge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 304,
    viewBox: "0 0 790 578",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    width: 578,
    height: 578,
    fill: "url(#pattern0)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395,
    cy: 421.5,
    rx: 395,
    ry: 48.5,
    fill: "url(#paint0_radial_6927_3238)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.532,
    cy: 421.501,
    rx: 254.126,
    ry: 9.7,
    fill: "url(#paint1_radial_6927_3238)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.05 179.733C391.792 176.291 398.209 176.291 402.95 179.733L495.317 246.767C500.067 250.213 502.054 256.328 500.239 261.908L464.964 370.353C463.15 375.927 457.954 379.701 452.092 379.701H337.908C332.046 379.701 326.85 375.927 325.036 370.353L289.761 261.908C287.946 256.328 289.934 250.213 294.683 246.767L387.05 179.733Z",
    fill: "url(#paint2_linear_6927_3238)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6927_3238)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.992 213.457C393.377 211.705 396.623 211.705 399.008 213.457L465.485 262.313C467.846 264.049 468.822 267.107 467.903 269.89L442.544 346.636C441.628 349.408 439.038 351.28 436.118 351.28H353.882C350.962 351.28 348.372 349.408 347.456 346.636L322.097 269.89C321.178 267.107 322.154 264.049 324.515 262.313L390.992 213.457Z",
    fill: "url(#paint3_radial_6927_3238)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M390.992 213.457C393.377 211.705 396.623 211.705 399.008 213.457L465.485 262.313C467.846 264.049 468.822 267.107 467.903 269.89L442.544 346.636C441.628 349.408 439.038 351.28 436.118 351.28H353.882C350.962 351.28 348.372 349.408 347.456 346.636L322.097 269.89C321.178 267.107 322.154 264.049 324.515 262.313L390.992 213.457Z",
    fill: "url(#paint4_radial_6927_3238)",
    fillOpacity: 0.29
  })), /*#__PURE__*/React.createElement("path", {
    d: "M390.992 213.457C393.377 211.705 396.623 211.705 399.008 213.457L465.485 262.313C467.846 264.049 468.822 267.107 467.903 269.89L442.544 346.636C441.628 349.408 439.038 351.28 436.118 351.28H353.882C350.962 351.28 348.372 349.408 347.456 346.636L322.097 269.89C321.178 267.107 322.154 264.049 324.515 262.313L390.992 213.457Z",
    fill: "url(#paint5_linear_6927_3238)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M468.691 257.951L402.214 209.095C397.922 205.94 392.078 205.94 387.786 209.095L321.309 257.951C317.058 261.075 315.301 266.58 316.956 271.589L342.315 348.334C343.964 353.324 348.627 356.694 353.882 356.694H436.118C441.373 356.694 446.036 353.324 447.685 348.334L473.044 271.589C474.699 266.58 472.942 261.075 468.691 257.951Z",
    stroke: "url(#paint6_linear_6927_3238)",
    strokeWidth: 10.8283
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M471.83 253.056L405.878 204.192C399.416 199.404 390.584 199.404 384.122 204.192L318.17 253.056C311.846 257.741 309.233 265.95 311.684 273.429L336.848 350.202C339.308 357.708 346.313 362.783 354.212 362.783H435.789C443.688 362.783 450.692 357.708 453.153 350.202L478.316 273.429C480.768 265.95 478.155 257.741 471.83 253.056Z",
    stroke: "url(#paint7_linear_6927_3238)",
    strokeWidth: 1.35354
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6927_3238",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 321,
    y: 212,
    width: 148,
    height: 140
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M390.992 213.455C393.377 211.703 396.623 211.703 399.008 213.455L465.485 262.311C467.846 264.047 468.822 267.105 467.903 269.888L442.544 346.634C441.628 349.406 439.038 351.278 436.118 351.278H353.882C350.962 351.278 348.372 349.406 347.456 346.634L322.097 269.888C321.178 267.105 322.154 264.047 324.515 262.311L390.992 213.455Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6927_3238)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_6927_3238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.439 267.598C431.382 271.54 434.067 276.563 435.157 282.031C436.246 287.499 435.69 293.167 433.56 298.319C431.43 303.471 427.82 307.877 423.187 310.978C418.554 314.08 413.106 315.739 407.531 315.746C401.955 315.753 396.503 314.107 391.862 311.017C387.222 307.927 383.601 303.53 381.458 298.383C379.315 293.236 378.745 287.57 379.821 282.099C380.897 276.629 383.57 271.6 387.503 267.647C390.119 265.018 393.229 262.93 396.654 261.504C400.079 260.078 403.751 259.342 407.461 259.337C411.171 259.333 414.845 260.06 418.273 261.477C421.701 262.895 424.816 264.975 427.439 267.598Z",
    fill: "url(#paint8_radial_6927_3238)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.619 265.015C377.939 265.301 372.582 267.743 368.64 271.843C364.698 275.943 362.468 281.392 362.405 287.079C362.342 292.766 364.451 298.263 368.301 302.45C372.151 306.636 377.453 309.196 383.126 309.608C377.579 303.478 374.549 295.481 374.641 287.215C374.732 278.948 377.938 271.021 383.619 265.015Z",
    fill: "url(#paint9_radial_6927_3238)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.536 273.341C357.916 273.891 354.625 275.754 352.289 278.574C349.954 281.395 348.737 284.976 348.872 288.635C349.006 292.294 350.481 295.776 353.017 298.418C355.553 301.06 358.972 302.676 362.622 302.96C359.586 298.661 357.866 293.572 357.673 288.312C357.481 283.053 358.823 277.851 361.536 273.341Z",
    fill: "url(#paint10_radial_6927_3238)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.582 264.326C386.536 264.128 386.469 263.932 386.382 263.742C385.862 262.613 384.707 261.914 383.466 261.977C377.012 262.302 370.926 265.077 366.447 269.735C365.695 270.517 364.998 271.342 364.358 272.205C364.281 272.012 364.182 271.826 364.064 271.649C363.408 270.669 362.245 270.157 361.079 270.334C356.721 270.996 352.758 273.239 349.947 276.634C347.135 280.03 345.67 284.341 345.832 288.746C345.993 293.152 347.77 297.344 350.823 300.524C353.876 303.705 357.992 305.651 362.387 305.993C363.562 306.084 364.685 305.488 365.267 304.463C365.371 304.281 365.454 304.091 365.517 303.896C365.695 304.103 365.877 304.307 366.062 304.509C370.437 309.265 376.46 312.174 382.905 312.642C384.145 312.732 385.314 312.059 385.859 310.942C385.96 310.735 386.036 310.52 386.087 310.302C387.352 311.491 388.719 312.578 390.176 313.549C395.317 316.972 401.358 318.796 407.534 318.788C413.711 318.78 419.747 316.942 424.879 313.506C430.012 310.07 434.011 305.189 436.371 299.481C438.731 293.773 439.347 287.494 438.14 281.436C436.933 275.379 433.958 269.815 429.59 265.447C426.684 262.541 423.233 260.237 419.435 258.667C415.637 257.096 411.567 256.29 407.457 256.295C403.347 256.301 399.279 257.116 395.485 258.696C392.216 260.057 389.207 261.962 386.582 264.326Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 6.08333,
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6927_3238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.956 289.253C398.83 289.034 398.623 288.875 398.379 288.81C398.136 288.745 397.877 288.779 397.658 288.904L394.705 290.608C394.429 290.766 394.187 290.979 393.995 291.233C393.803 291.488 393.665 291.778 393.588 292.088C393.441 292.701 393.538 293.347 393.859 293.891L394.118 294.338C394.433 294.884 394.952 295.281 395.56 295.444C396.169 295.607 396.817 295.522 397.362 295.207L400.313 293.506C400.421 293.444 400.516 293.361 400.592 293.262C400.668 293.163 400.724 293.05 400.757 292.929C400.789 292.809 400.797 292.683 400.781 292.559C400.765 292.435 400.724 292.316 400.662 292.208L398.956 289.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.31 300.587L409.718 289.49C409.705 289.462 409.702 289.431 409.711 289.402C409.719 289.373 409.739 289.348 409.765 289.333L410.258 289.049C410.366 288.986 410.461 288.903 410.537 288.804C410.613 288.705 410.669 288.592 410.701 288.472C410.734 288.351 410.742 288.225 410.726 288.101C410.709 287.978 410.669 287.858 410.606 287.75L407.783 282.859C407.72 282.751 407.637 282.656 407.538 282.58C407.439 282.504 407.326 282.448 407.206 282.416C407.085 282.383 406.959 282.375 406.836 282.391C406.712 282.407 406.592 282.448 406.484 282.51L401.353 285.469C401.082 285.624 400.844 285.831 400.654 286.079C400.464 286.327 400.325 286.61 400.245 286.911C400.19 287.1 400.163 287.295 400.163 287.491C400.167 287.943 400.71 288.84 401.24 289.765C401.809 290.76 402.383 291.778 402.804 292.032C403.073 292.193 403.547 292.323 403.946 292.323H403.996L399.283 302.517C399.231 302.63 399.201 302.753 399.196 302.878C399.191 303.003 399.211 303.127 399.254 303.244C399.297 303.362 399.362 303.469 399.447 303.561C399.532 303.653 399.634 303.727 399.747 303.779C399.861 303.832 399.983 303.861 400.108 303.866C400.233 303.871 400.357 303.852 400.475 303.808C400.592 303.765 400.699 303.699 400.791 303.615C400.883 303.53 400.957 303.428 401.009 303.314L406.574 291.275C406.615 291.186 406.683 291.112 406.768 291.063L407.909 290.405C407.923 290.397 407.939 290.392 407.955 290.39C407.971 290.388 407.987 290.39 408.003 290.394C408.018 290.399 408.032 290.407 408.045 290.417C408.057 290.428 408.067 290.441 408.074 290.455L413.612 301.445C413.668 301.557 413.746 301.656 413.84 301.738C413.935 301.819 414.044 301.881 414.163 301.92C414.282 301.959 414.407 301.975 414.531 301.966C414.656 301.956 414.777 301.923 414.889 301.867C415 301.81 415.099 301.733 415.181 301.638C415.262 301.544 415.324 301.434 415.364 301.315C415.403 301.197 415.418 301.072 415.409 300.947C415.4 300.823 415.366 300.701 415.31 300.59V300.587ZM421.688 281.276L418.948 276.539C418.632 275.994 418.113 275.597 417.505 275.434C416.897 275.272 416.249 275.356 415.703 275.67L410.158 278.865C409.887 279.02 409.649 279.228 409.459 279.475C409.269 279.723 409.13 280.006 409.05 280.308C408.971 280.562 408.946 280.83 408.975 281.095C409.078 281.844 409.747 282.901 410.543 284.296C411.35 285.706 412.261 287.295 412.737 287.639C413.14 287.924 413.621 288.077 414.114 288.077C414.53 288.077 414.938 287.968 415.298 287.76L420.844 284.563C421.12 284.405 421.361 284.193 421.553 283.939C421.745 283.685 421.883 283.396 421.96 283.087C422.109 282.471 422.011 281.821 421.688 281.276Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6927_3238",
    transform: "scale(0.002)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6927_3238",
    x: 310.926,
    y: 201.314,
    width: 168.148,
    height: 160.793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.4547
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7875 0 0 0 0 0.62959 0 0 0 0 0.246094 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6927_3238"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_6927_3238",
    x: 339.128,
    y: 253.254,
    width: 106.305,
    height: 77.0928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.86667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.825
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6927_3238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6927_3238",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.21667,
    dy: 2.43333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.51667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.835294 0 0 0 0 0.623529 0 0 0 0 0.176471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6927_3238"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6927_3238",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395 421.5) rotate(90) scale(48.5 395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCECC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6927_3238",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424.532 421.501) rotate(90) scale(9.7 254.126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCECC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6927_3238",
    x1: 351.01,
    y1: 179.377,
    x2: 428.162,
    y2: 360.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D169"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_6927_3238",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395 284.01) rotate(90) scale(114.488 122.526)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECC2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1A420"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_6927_3238",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(360.209 257.155) rotate(-42.3062) scale(78.7465 41.6259)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6927_3238",
    x1: 395,
    y1: 210.512,
    x2: 395,
    y2: 357.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#765913",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#816011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6927_3238",
    x1: 395,
    y1: 210.512,
    x2: 395,
    y2: 357.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6927_3238",
    x1: 395,
    y1: 196.975,
    x2: 395,
    y2: 362.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEAC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE296"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_6927_3238",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(436.021 276.179) rotate(-177.111) scale(117.649 269.663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9DDA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7E1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_6927_3238",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(436.021 276.179) rotate(-177.111) scale(117.649 269.663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9DDA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7E1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_6927_3238",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(436.021 276.179) rotate(-177.111) scale(117.649 269.663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9DDA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7E1D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6927_3238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.4167,
    height: 30.4167,
    fill: "white",
    transform: "translate(392.566 274.4)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6927_3238",
    width: 500,
    height: 500,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel3Badge);
export default __webpack_public_path__ + "static/media/Level3Badge.4e752eb4cfd53a9fa3d3ad97a86dfeed.svg";
export { ForwardRef as ReactComponent };